import { call, put, takeLatest } from "redux-saga/effects";
import { addSignatureStart, addSignatureSuccess, addSignatureFailure,getSignaturesStart,getSignaturesFailure,getSignaturesSuccess,updateSignatureStart,
  updateSignatureSuccess,
  updateSignatureFailure, } from "./signaturesSlice";
import { savesignaturesApi,fetchallsignatures,updatesignaturesApi } from "./signaturesApi";
import { showToast } from "../../../components"; 


// function* addSignatureSaga(action) {
//   try {
//     const payload = action.payload;
//     const response = yield call(savesignaturesApi, payload);

//     if (response?.data) {
//       yield put(addSignatureSuccess(response.data));
//       yield call(showToast, "Signature added successfully!", "success", 2000);
//     } else {
//       yield put(addSignatureFailure("Failed to add signature"));
//       yield call(showToast, "Failed to add signature", "error", 2000);
//     }
//   } catch (error) {
//     const message = error?.response?.data?.message || error.message || "Error adding signature";
//     yield put(addSignatureFailure(message));
//     yield call(showToast, message, "error", 2000);
//   }
// }
function* addSignatureSaga(action) {
  try {
    const payload = action.payload;
    const response = yield call(savesignaturesApi, payload);

    if (response?.data) {
      yield put(addSignatureSuccess(response.data));
      yield call(showToast, "Signature added successfully!", "success", 2000);

      // ✅ After successful save, automatically fetch updated signatures
      const refreshParams = {
        coll: "Signature",
        fil: JSON.stringify({
          addedBy: { type: "NONE", value: payload.payload.addedBy },
        }),
        lim: 50,
      };
      yield put(getSignaturesStart(refreshParams));
    } else {
      yield put(addSignatureFailure("Failed to add signature"));
      yield call(showToast, "Failed to add signature", "error", 2000);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message || error.message || "Error adding signature";
    yield put(addSignatureFailure(message));
    yield call(showToast, message, "error", 2000);
  }
}



function* getSignaturesSaga(action) {
  try {
    const params = action.payload; 
    const response = yield call(fetchallsignatures, params);

    if (response?.data) {
      yield put(getSignaturesSuccess(response.data));
    } else {
      yield put(getSignaturesFailure("Failed to fetch signatures"));
    }
  } catch (error) {
    const message = error?.response?.data?.message || error.message || "Error fetching signatures";
    yield put(getSignaturesFailure(message));
  }
}
function* updateSignatureSaga(action) {
  try {
    const { uiid, payload } = action.payload;
    const response = yield call(updatesignaturesApi, { uiid, payload });

    if (response?.data) {
      yield put(updateSignatureSuccess(response.data));
      yield call(showToast, "Signature updated successfully!", "success", 2000);
    } else {
      yield put(updateSignatureFailure("Failed to update signature"));
      yield call(showToast, "Failed to update signature", "error", 2000);
    }
  } catch (error) {
    const message =
      error?.response?.data?.message || error.message || "Error updating signature";
    yield put(updateSignatureFailure(message));
    yield call(showToast, message, "error", 2000);
  }
}


export function* watchSignatureSaga() {
  yield takeLatest(addSignatureStart.type, addSignatureSaga);
  yield takeLatest(getSignaturesStart.type, getSignaturesSaga);
yield takeLatest(updateSignatureStart.type, updateSignatureSaga);
}
